module.exports = __webpack_public_path__ + "static/akmon_hammer_of_purphoros-b13a3332bbf679d5a859d5f4a101e25c.jpeg";